
export const PageHeader = {
    
    init() {
       

        // Funnel DNI
        if($('.dni_property_id').length > 0 ){
            var propertyId = $('.dni_property_id').val();
            if( $(".lead_source_schedule").val() == ''){
                $(".contact-us-form #input_2_17").val('10491');
                $(".lead_source_schedule").val('10491');
            }
            setTimeout(function(){
                FunnelDNI({
                    "apiKey": "b96edc336cf043fa830d9e92f4ec7e6d",
                    "communityId": propertyId,
                    "onPhoneNumberReady": function(data) {
                        if(data.lead_source_id == ''){
                            $(".contact-us-form #input_2_17").val('10491');
                            $(".lead_source_schedule").val('10491');
                        }else{
                            $(".contact-us-form #input_2_17").val(data.lead_source_id);
                            $(".lead_source_schedule").val(data.lead_source_id);
                        }
                    }
                });

            },500);
        }

        // For general contact form
        function setHelpWithSelect() {
            const selectWrapper = document.querySelector('.help-with-select');
            if (selectWrapper) {
                const select = selectWrapper.querySelector('select');
                if (select) {
                    select.value = 'Resident Relations';
                    // Trigger both native change event and Gravity Forms change event
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                    // Also trigger Gravity Forms specific event
                    if (window.gform) {
                        gform.utils.trigger({ event: 'gform/conditionalLogic/init/end', native: false, data: { formId: select.closest('form').id } });
                    }
                }
            }
        }
        
        // 1. Handle direct URL with #contact-form-section
        if (window.location.hash === '#contact-form-section') {
            setHelpWithSelect();
    
            // Optional: smooth scroll to the section in case browser doesn't scroll automatically
            const target = document.querySelector('#contact-form-section');
            if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
            }
        }
    
        // 2. Handle anchor click to #contact-form-section
        const contactLinks = document.querySelectorAll('a[href="#contact-form-section"]');
        contactLinks.forEach(contactLink => {
            contactLink.addEventListener('click', function (e) {
                e.preventDefault();
                setHelpWithSelect();
        
                const target = document.querySelector('#contact-form-section');
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                }
        
                // Update URL hash manually
                history.pushState(null, '', '#contact-form-section');
            });
        });
    },
};

